import ProcessingNodeBase from '~/models/journey/ProcessingNodeBase'
import { EngineStore } from '~/stores/engine'

export class RunEngineNode extends ProcessingNodeBase {
  run(): Promise<void> {
    EngineStore.run()
    return Promise.resolve(undefined)
  }
}
